import { useSyncExternalStore } from 'react';

import { getSession, subscribeSession, type SessionState } from './session';

const UNKNOWN: SessionState = { status: 'unknown' };

function serverSession(): SessionState {
  return UNKNOWN;
}

/** Текущий сеанс. Меняется из любого места приложения, включая перехватчик 401. */
export function useSession(): SessionState {
  return useSyncExternalStore(subscribeSession, getSession, serverSession);
}
